import React, { useState, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import axios from 'axios';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  makeStyles,
} from "@material-ui/core";

import { Routes } from "../app/Routes";
import { I18nProvider } from "../_metronic/i18n";
import { LayoutSplashScreen, MaterialThemeProvider } from "../_metronic/layout";
import history from "../utils/history";
import { PLAN_LIST_URL } from "../constants";
import { ClearCacheProvider, useClearCacheCtx } from 'react-clear-cache';

const useStyles = makeStyles({
  alertMessageDiv: {
    fontWeight: "500",
    fontSize: "1.1rem",
    lineHeight: "24px",
    letterSpacing: "0.05em",
    color: "#1D1D1D",
  },
  notificationDialog: {
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgba(0, 0, 0, 0.8) !important'
    }
  }
});

export default function App({ basename }) {
  
  const [openAlertMessage, setOpenAlertMessage] = useState(false);
  const [alertMessage, setalertMessage] = useState({});
  const classes = useStyles();

  navigator.geolocation.getCurrentPosition(
    function(position) {
      // console.log('position', position);
    },
    function(error) {
      switch (error.code) {
        // PERMISSION_DENIED
        case 1:
          console.log('Permission denied')
          break
        // POSITION_UNAVAILABLE
        case 2:
          console.log('Permission allowed, location disabled')
          break
        // TIMEOUT
        case 3:
          console.log('Permission allowed, timeout reached')
          break
        }
    },
    {timeout: 0}
  );
  
  /* navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
    if (result.state == 'granted') {
      // console.log(result);      
    } else if (result.state == 'prompt') {
      // console.log(result.state);      
    } else if (result.state == 'denied') {
      console.log('Location permission denied')
    }
  }); */

  axios.interceptors.response.use(
    function (response) {
      if (
        response.data !== undefined &&
        response.data.status !== undefined &&
        response.data.status === 401
      ) {
        window.localStorage.removeItem('clientpanel');
        window.location.href = '/login';
      } else if (response.data !== undefined &&
        response.data.status !== undefined &&
        response.data.status === 403) {
          if(history.location.pathname !== '/plans-and-payment') {
            setOpenAlertMessage(true);
            setalertMessage({ notification: response.data.error });            
          }
          return {data: {status: 403}};
      } else {
        return response;
      }
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  return (
    <React.Suspense fallback={<LayoutSplashScreen />}>
      <ClearCacheProvider duration={10000}>
        {/* Override `basename` (e.g: `homepage` in `package.json`) */}
        <BrowserRouter basename={basename} history={history}>
          {/*This library only returns the location that has been active before the recent location change in the current window lifetime.*/}
          <MaterialThemeProvider>
            {/* Provide `react-intl` context synchronized with Redux state.  */}
            <I18nProvider>
              {/* Render routes with provided `Layout`. */}
              <Routes history={history} />

              {/* Plan notification for Owner */}
              <Dialog
                open={openAlertMessage}
                fullWidth={true}
                maxWidth={`xs`}
                aria-labelledby="notification-alert-title"
                aria-describedby="notification-alert"
                className={classes.notificationDialog}
              >
                <DialogContent>
                  <DialogContentText
                    id="notification-alert"
                    dangerouslySetInnerHTML={{ __html: alertMessage.notification }}
                    className={classes.alertMessageDiv}
                  ></DialogContentText>
                </DialogContent>

                <DialogActions style={{ justifyContent: "center", padding: 25 }} >
                  <Button
                    variant="contained"
                    className="btn btn-primary"
                    onClick={() => window.location.href = PLAN_LIST_URL}
                  >
                    Renew Now
                  </Button>
                </DialogActions>

              </Dialog>
            </I18nProvider>
          </MaterialThemeProvider>
        </BrowserRouter>
      </ClearCacheProvider>
    </React.Suspense>
  );
}
